import React from 'react';
import { useFormContext } from 'react-hook-form';

import {
  IBenefits,
  ICreateBenefitGroupForm
} from '@epi-models/pages/BenefitGroups';

import { BenefitCheckbox } from '../BenefitCheckbox';

interface BenefitTypeCardProps {
  benefitType: IBenefits;
  maxAmount: number;
  disabled?: boolean;
}

export const BenefitTypeCard = ({
  benefitType,
  maxAmount,
  disabled
}: BenefitTypeCardProps) => {
  const { watch, setValue, formState, trigger } =
    useFormContext<ICreateBenefitGroupForm>();

  const value = watch(`benefitSettings.${benefitType}`);

  const handleToggleCheckbox = () => {
    if (disabled) {
      return null;
    }
    if (value) {
      setValue(`benefitSettings.${benefitType}`, undefined, {
        shouldDirty: true,
        shouldValidate: true
      });
    } else {
      const defaultValue =
        formState.defaultValues?.benefitSettings?.[benefitType];
      setValue(
        `benefitSettings.${benefitType}`,
        defaultValue || { maxAmountPerPeriod: maxAmount },
        { shouldDirty: true, shouldValidate: true }
      );
    }
    trigger();
  };

  return (
    <BenefitCheckbox
      benefitType={benefitType}
      disabled={disabled}
      handleToggleCheckbox={handleToggleCheckbox}
      isChecked={!!value}
    />
  );
};
